import React, { useEffect, useState } from "react";
import Select from "react-select";
import employeeAccountStatusFormat from "../../../utils/FormatEmployeeAccountStatus/employeeAccountStatusFormat";
import { useUpdateEmployeeAccountStatus } from "../../../queries/employeeQueries";
import { toast } from "react-toastify";
import { employementStatus } from "../../../utils/commonSelectBoxOptions/commonSelectBoxOptions";

const EmployementStatus = ({ status, employee_id ,disabled = false }) => {

 // console.log("EmployementStatus component rendered with status:", status, "and employee_id:", employee_id);
  const [selectedStatus, setSelectedStatus] = useState(status || 0);
  const [pendingStatus, setPendingStatus] = useState(null);
  const [showDialog, setShowDialog] = useState(false);

  const { mutate: updateStatus } = useUpdateEmployeeAccountStatus();

  useEffect(() => {
    setSelectedStatus(status);
  }, [status]);

  const handleStatusChange = (selectedOption) => {
    setPendingStatus(selectedOption.value);
    setShowDialog(true);
  };

const confirmUpdate = () => {
  setSelectedStatus(pendingStatus);
  setShowDialog(false);

  if (employee_id && pendingStatus !== null) {
    updateStatus(
      {
        employee_id,
        account_status: pendingStatus
      },
      {
        onSuccess: (data) => {
          if (data?.status) {
            toast.success(data?.message || "Employee status updated successfully");
          } else {
            toast.error(data?.message || "Failed to update status");
          }
        },
        onError: (error) => {
          const message = error?.response?.data?.message || "Something went wrong";
          toast.error(message);
        }
      }
    );
  }
};


  const cancelUpdate = () => {
    setPendingStatus(null);
    setShowDialog(false);
  };

 const accountStatus = employeeAccountStatusFormat(selectedStatus) || {
  label: "Unknown",
  borderColor: "#ccc",
  bgColor: "#f9f9f9",
  fontColor: "#000"
};

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: accountStatus.borderColor,
      background: accountStatus.bgColor,
      boxShadow: state.isFocused
        ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
        : null,
      "&:hover": {
        boxShadow: "0 0 0 0.2rem rgba(0, 123, 255, 0.25)",
      }
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? state.data.color : null,
      color: "black"
    }),
    singleValue: (provided) => ({
      ...provided,
      color: accountStatus.fontColor
    })
  };

  return (
    <>
      <Select
        isDisabled={disabled}
  className="text-sm leading-5 font-medium"
  options={employementStatus.filter((opt) => opt.value !== "0" && opt.value !== 0)}
  value={{
    label: accountStatus.label,
    value: selectedStatus
  }}
  onChange={handleStatusChange}
  styles={customStyles}
/>

      {showDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
            <h2 className="text-lg font-semibold mb-4">Confirm Update</h2>
            <p className="text-sm text-gray-700 mb-6">
              Are you sure you want to update the employee's status?
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={cancelUpdate}
                className="px-4 py-2 text-sm rounded bg-gray-200 hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={confirmUpdate}
                className="px-4 py-2 text-sm rounded bg-blue-600 text-white hover:bg-blue-700"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EmployementStatus;
